<template>
    <div class="ku-goods-success">
        <div class="top">
            <img class="logo" src="../../assets/thank.png" style="object-fit: cover" alt="thank you">
            <div class="re">
                <span>{{ name }}</span>
            </div>
            <div class="s2">请长按关注公众号</div>
            <div class="s3">预计25-50分钟到达<br>请留意公众号消息推送</div>
            <img class="qrcode" src="../../assets/qrcode.jpg" style="object-fit: cover" alt="qrcode">
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {Button, Image as VanImage} from 'vant';

Vue.use(VanImage).use(Button);
export default {
    name: "index",
    data() {
        return {
            name: ''
        }
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        onLoad() {
            let that = this
            this.$API.reminder().then(res => {
                return res;
            }).then(res => {
                that.name = res.data.msg
            })
        }
    },
}
</script>

<style lang="less" scoped>
@import "/src/styles/base.less";
.ku-goods-success {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #F7F7F7;
    .top {
        width: 80%;
        height: auto;
        border: 1px solid #F0DAB3;
        border-radius: 15px;
        background: white;
        padding: 30px 15px;
        margin: 30px auto;
        .logo {
            width: 100%;
        }
        .qrcode {
            width: 50%;
        }
        span{
            display: block;
            color: #D42D27;
            &.number {
                font-size: 200px;
                font-weight: bold;
                padding-top: 30px;
            }
            &.name {
                font-size: 50px;
            }
        }
        .s1 {
            .van-button {
                width: 150px;
                height: 50px;
                padding: 5px 20px;
                margin: 30px 5px 0 5px;
                border-radius: 15px;
                background: #E79A30;
                .van-button__text {
                    color: white;
                }
            }
        }
        .s2 {
            font-size: 32px;
            padding: 15px 0;
            font-weight: bold;
            letter-spacing: 2px;
        }
        .s3 {
            font-size: 34px;
            padding: 15px 0;
            letter-spacing: 2px;
        }
        .re {
            span {
                width: 80%;
                font-size: 42px;
                line-height: 100px;
                background: @gray-2;
                color: @white;
                margin: 15px auto;
                border-radius: 8px;
            }
        }
    }
    &>.van-button {
        background: #3C834B;
        border-color: #3C834B;
        width: 185px;
        height: 70px;
        border-radius: 8px;
        font-size: 32px;
    }
}
</style>
